<template>
  <span>
    <svg
      width="264"
      height="295"
      viewBox="0 0 264 295"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M174.088 114.738L124.694 106.087C116.679 104.676 110.936 102.506 107.15 99.553C105.319 98.1463 103.851 96.3205 102.869 94.2286C101.888 92.1367 101.423 89.8397 101.511 87.5303C101.511 82.094 104.017 77.7554 108.873 74.7236C113.755 71.6918 120.882 70.0713 130.333 70.0713C140.619 70.0713 147.877 72.1361 152.759 75.377C157.641 78.644 160.121 82.9565 160.878 87.5303C161.661 91.7644 163.045 94.4564 165.107 96.103C167.331 97.7174 170.04 98.52 172.783 98.3769H244.733C249.485 98.3769 252.852 96.9655 255.019 94.5871C257.223 92.0707 258.389 88.8103 258.283 85.4656C256.873 60.1918 246.247 38.8385 225.78 23.7579C205.286 8.67725 174.741 0 133.466 0H124.798C84.1762 0 53.0046 9.53975 31.9625 25.9272C10.9465 42.1839 0.00774021 65.2884 0.00774021 92.1826C0.00774021 113.222 6.82162 131.126 20.5799 145.109C34.3382 159.118 55.041 169.076 82.7664 174.381L136.494 184.574C145.162 186.012 151.349 188.181 155.343 191.527C159.364 194.898 161.217 199.106 161.217 204.987C161.25 207.692 160.588 210.36 159.294 212.736C158.001 215.111 156.119 217.114 153.829 218.551C148.973 221.792 141.716 223.753 132.291 223.753C122.109 223.753 114.721 222.001 109.63 218.656C104.539 215.18 101.72 210.083 100.65 203.131C100.482 200.729 99.3974 198.483 97.6212 196.858C95.3415 194.982 92.4503 194.014 89.5019 194.14H13.2178C11.3264 194.026 9.43409 194.349 7.68692 195.083C5.93974 195.817 4.38437 196.943 3.14057 198.374C1.00522 201.085 -0.104412 204.464 0.00774021 207.914C1.20865 233.841 10.7115 255.639 31.7536 270.902C52.7696 286.218 85.2726 295 132.395 295H139.549C177.247 295 208.445 286.323 230.113 270.275C251.782 254.332 264 231.018 264 201.955C264 178.746 256.742 159.431 241.914 144.69C227.059 130.054 204.529 119.861 174.088 114.738Z"
        fill="#00FFE0"
      />
    </svg>
  </span>
</template>
<script setup lang="ts"></script>
<style scoped lang="postcss">
span {
  display: inline-block;
  > svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
